'use strict';

var baggagesObserverMixin = require('../modules/mixins/baggages_observer.mixin');

Odigeo.defineWidget('smart_nag_baggage', Odigeo.Widget.extend(baggagesObserverMixin.extend({
    viewClass: require('../modules/views/smart_nag_baggage.view'),
    modelClass: require('../modules/models/smart_nag_baggage.model'),

    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
    },
    showSmartNagBaggage: function() {
        this.model.loadData();
        this.view.showSmartNagBaggage();
    },

    setPassengersData: function(data) {
        this.model.setPassengersData(data);
    },

    proceedToPayment: function() {
        Odigeo.trigger('nagmanager:continue');
    },

    updateBaggageAndProceedToPayment: function() {
        this.model.saveBaggageData();
        this.proceedToPayment();
    },

    exposedMethods: {
        showSmartNagBaggage: 'showSmartNagBaggage',
        setPassengersData: 'setPassengersData',
    },
})));
